import { useEffect } from 'react'
import { SinglePageNav } from './Nav'


const QACard = ({ q, a, cls }) => {
    return (
        <div className={'mb-2 card ' + cls}>
            <div className="card-body">
                <h5 className="card-title">{q}</h5>
                <p className="card-text">{a}</p>
            </div>
        </div>
    )
}

export const QA = ({ theme, onClose }) => {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        })
    }, [])

    const cls = theme === 'dark' ? 'text-white bg-dark' : 'text-black bg-light'
    const bgCls = theme === 'dark' ? 'text-white bg-black' : 'text-black bg-light'
    return (
        <>
            <SinglePageNav theme={theme} title="常見問題" onBack={onClose} />
            <div className={'min-vh-100 pt-2 container-fluid ' + bgCls}>
                <QACard
                    cls={cls}
                    q="為何沒有庫存損益、已實損益等資訊？總損益是怎麼計算的呢？"
                    a="記帳本為了維持懶人精神，個股總損益是用『所有交易紀錄加總計算的』。
                有別於一般券商App採用先進先出的邏輯，每次賣出時都計算損益並扣除股票後重新計算均價。
                需要額外紀錄每次賣出損益的狀況，才能追蹤該檔股票長期績效。
                記帳本採用比較單純的累計方式（股利也會計入），一眼看出長期投資的累積報酬率。
                "
                />
                <QACard
                    cls={cls}
                    q="為何費用差了1塊？交易成本如何計算？"
                    a="各家券商針對手續費的小數位數處理方式都不同，同時還要考慮折讓時的進位問題。
                記帳本統一採用『四捨五入』計算市值、『無條件捨去』計算成本，因此可能跟實際的帳單會有些許的出入。
                除了買、賣固定的手續費1.425‰之外，賣出時也會根據不同的交易類型套入不同的稅費！
                "
                />
                <QACard
                    cls={cls}
                    q="均價、市值如何計算？總損益有考慮賣出成本嗎？"
                    a="均價代表過去所有買入操作的平均價格，未將交易成本及已實現損益列入考慮，這樣可以直覺的看出實際下單價格，方便理解過去的買點；
                市值也未列入可能交易成本，以『現價Ｘ持股股數』計算，因未實現的情況下無法正確的推算實際的交易成本。
                記帳本總損益計算：已實現部分為扣除所有費用後的實際損益，未實現部分與市值一樣忽略賣出成本！不過計算方式會持續收集使用者意見而調整，盡量貼近理想方式呈現！
                "
                />
                <QACard
                    cls={cls}
                    q="下市、減資怎麼記帳？"
                    a="開發者身為股市菜雞自己還沒遇過下市、減資等情況，但目前想到的因應方式就是開放『股利』交易選項輸入『負數的股數』，
                    這樣就可以在完全不動現有紀錄的狀況下減少持股，如果有退還現金就當作現金股利紀錄，原則上可以維持累積的投資損益資訊是正確的。"
                />
                <QACard
                    cls={cls}
                    q="股票交易紀錄越來越多怎麼辦？太久以前的交易可不可以不要列入總損益？"
                    a="在個股操作資料中，點擊右上方選單「封存」，就可以將交易紀錄移至封存區喔！封存區的損益不會影響到首頁上的結算結果
                    封存區的紀錄也可以隨時恢復到個股操作資料中！"
                />
                <div className={'p-2 alert alert-' + theme}>
                    有任何建議除了Play上的評論外，也可email到 lt.studio.tw@outlook.com 做更多交流！
                </div>
                <div className="mt-2 w-100 text-muted text-right">祝投資順利，財富自由   © 2021 LTStudio</div>
            </div>
        </>
    )
}